import { render, staticRenderFns } from "./TreeFacet.vue?vue&type=template&id=17353982&"
import script from "./TreeFacet.vue?vue&type=script&lang=js&"
export * from "./TreeFacet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/srv/www/finda/current/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17353982')) {
      api.createRecord('17353982', component.options)
    } else {
      api.reload('17353982', component.options)
    }
    module.hot.accept("./TreeFacet.vue?vue&type=template&id=17353982&", function () {
      api.rerender('17353982', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "buysearchsell/vue/components/refinements/TreeFacet.vue"
export default component.exports